import { API_BASE_URL } from "src/config/apiBase";
import { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import './LeadsUpdatedVersion.css';
import { readFirstSheetAsJson } from "../../utils/excelSheet";
import ScrollToTopButton from './ScrollToTopButton';
import EnquiryFormModal from './EnquiryFormModal'
import { useSidebar } from '../../SidebarContext';
import Sidebar from '../SideBar';
import { toast } from "react-toastify";
import CRMUpdatedVersionCards from './CRMUpdatedVersionCards';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';
import { CheckCircle, Clock, Clock1, Hourglass, Phone, PhoneCall, UserPlus, Users2, XCircle } from 'lucide-react';
import FilterTabs from './FilterTabs';
import { useLocation } from 'react-router-dom';
import {
    ensureCrmNotificationPermission,
    syncCrmRemindersFromLeads,
} from '../../utils/crmReminderNotifications';





const CRMUpdatedVersion = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('all');
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [otherFilter, setOtherFilter] = useState('');
    const [searchCategory, setSearchCategory] = useState('');
    const [visibleCategories, setVisibleCategories] = useState(10);
    const [searchEnquiry, setSearchEnquiry] = useState('');
    const [visibleEnquiries, setVisibleEnquiries] = useState(10);
    const [showAssignSection, setShowAssignSection] = useState(false);
    const [showCheckAssignSection, setShowCheckAssignSection] = useState(false);
    const [showArchiveSection, setShowArchiveSection] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);

    const [selectedService, setSelectedService] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [enquiryInitialMode, setEnquiryInitialMode] = useState("manual");
    const [leads, setLeadsData] = useState([])
    const [entriesCount, setEntriesCount] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [showAssignSectionMain, setShowAssignSectionMain] = useState(false);
    const [showAssignSectionArchive, setShowAssignSectionArchive] = useState(false);


    const [selectedEmployees, setSelectedEmployees] = useState([]);

    const [selectAll, setSelectAll] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([]); // Store selected lead IDs
    const [staffList, setStaffList] = useState([]); // Store staff list
    const [notesData, setNotesData] = useState([]);
    const [employeeViewFilter, setEmployeeViewFilter] = useState(null);
    const [showExcelModal, setShowExcelModal] = useState(false);
    const [excelUploadSuccess, setExcelUploadSuccess] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [services, setServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [visibleCount, setVisibleCount] = useState(10);

    const [selectedDateOptions, setSelectedDateOptions] = useState([]); // ['today', 'yesterday', 'custom']
    const [customDate, setCustomDate] = useState({ from: '', to: '' });
    const [filterStarred, setFilterStarred] = useState(false);
    const [notes, setNotes] = useState('');
    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedEnquiryTypes, setSelectedEnquiryTypes] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [showFilterDrawer, setShowFilterDrawer] = useState(false);
    const [filterMode, setFilterMode] = useState('individual');
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [loadingHbtreal, setLoadingHbtreal] = useState(true);
    const [skippedEnquiries, setSkippedEnquiries] = useState([]);
    const [showSkippedModal, setShowSkippedModal] = useState(false);
    const url = API_BASE_URL
    const token = decryptToken("accessToken") || ""
    const [notConnectedFilter, setNotConnectedFilter] = useState(false);


    // new states
    const [avgRespondMinutes, setAvgRespondMinutes] = useState(0); // numeric average in minutes
    const [avgRespondDisplay, setAvgRespondDisplay] = useState("0m"); // formatted string
    const [isPoorRespond, setIsPoorRespond] = useState(false); // > 30 minutes threshold

    // helper: convert minutes (float) to nice string like "12h 30m" or "45m" or "2m 10s"
    function formatMinutesToReadable(mins) {
        if (!isFinite(mins) || mins <= 0) return "0m";
        const totalSeconds = Math.round(mins * 60);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (hours > 0) return `${hours}h ${minutes}m`;
        if (minutes > 0) return `${minutes}m ${seconds}s`;
        return `${seconds}s`;
    }





    const handleOtherChange = (event) => {
        setOtherFilter(event.target.value);
    };

    // const handleDateChange = (event) => {
    //     setSelectedDateFilter(event.target.value);
    // };

    const tabs = [
        { id: 'all enquiry', label: 'All Enquiry' },
        { id: 'new', label: 'New' },
        { id: 'assigned', label: 'Assigned' },
        { id: 'unassigned', label: 'Unassigned' },
        { id: 'archive', label: 'Archive' },
        { id: 'website', label: 'Website' }
    ];

    const allCategories = [
        'Education', 'Finance', 'Healthcare', 'Real Estate', 'Technology',
        'Hospitality', 'Retail', 'Automobile', 'Travel', 'Legal',
        'Fashion', 'Food & Beverage', 'Entertainment', 'Logistics', 'Manufacturing',
        'Construction', 'Consulting', 'Marketing', 'Media', 'Telecom'
    ];

    const handleCategorySearch = (e) => setSearchCategory(e.target.value);

    const filteredCategories = allCategories
        .filter(cat => cat.toLowerCase().includes(searchCategory.toLowerCase()))
        .slice(0, visibleCategories);

    const allEnquiries = ["Pending", "In Progress", "Cancelled", "Converted", "Not Interested"]

    const handleSearchEnquiryChange = (e) => setSearchEnquiry(e.target.value);
    const handleShowMoreEnquiry = () => setVisibleEnquiries(prev => prev + 10);

    const filteredEnquiries = allEnquiries
        .filter(enq => enq.toLowerCase().includes(searchEnquiry.toLowerCase()))
        .slice(0, visibleEnquiries);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const openEnquiryModal = (mode = "manual") => {
        setEnquiryInitialMode(mode);
        setShowEnquiryModal(true);
    };

    const closeEnquiryModal = () => {
        setShowEnquiryModal(false);
        setEnquiryInitialMode("manual");
        fetchLeadsData();
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("openEnquiry") === "true") {
            const voiceMode = params.get("voice") === "true" ? "voice" : "manual";
            const newUrl = `${window.location.pathname}`;
            window.history.replaceState({}, "", newUrl);
            openEnquiryModal(voiceMode);
        }
    }, [location]);

    const toggleFilterDrawer = () => {
        setShowFilterDrawer(prevState => !prevState);
    };

    const handleCheckboxDateChange = (e) => {
        const { value, checked } = e.target;
        setSelectedDateOptions((prev) =>
            checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
    };

    const handleStarredChange = (e) => setFilterStarred(e.target.checked);
    const handleWithNotesChange = (e) => setNotes(e.target.checked ? 'withNotes' : '');

    const toggleServiceSelection = (service) => {
        setSelectedServices((prev) =>
            prev.includes(service)
                ? prev.filter((s) => s !== service)
                : [...prev, service]
        );
    };

    const toggleEnquiryTypeSelection = (type) => {
        setSelectedEnquiryTypes((prev) =>
            prev.includes(type)
                ? prev.filter((t) => t !== type)
                : [...prev, type]
        );
    };

    const handleApplyFilters = () => {
        const datePriority = ['today', 'yesterday', 'custom'];
        const finalDate = datePriority.find((d) => selectedDateOptions.includes(d)) || '';
        setSelectedDate(finalDate);
        setFiltersApplied(true);
        setShowFilterDrawer(false);
        setFilterMode('combined');
    };

    const handleClearFilters = () => {
        setSelectedDateOptions([]);
        setCustomDate({ from: '', to: '' });
        setFilterStarred(false);
        setNotes('');
        setSelectedServices([]);
        setSelectedEnquiryTypes([]);
        setSelectedDate('');
        setFiltersApplied(false);
        setFilterMode('individual');
    };

    // const handleExcelUpload = async (e) => {
    //     const file = e.target.files[0];
    //     if (!file) return;

    //     const reader = new FileReader();
    //     reader.onload = async (event) => {
    //         const data = new Uint8Array(event.target.result);
    //         const workbook = XLSX.read(data, { type: "array" });
    //         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    //         let jsonData = XLSX.utils.sheet_to_json(worksheet);

    //         // ✅ Add user_id to each record
    //         jsonData = jsonData.map(entry => ({
    //             ...entry,
    //             user_id: isLoggedIn.user_id
    //         }));

    //         const xhr = new XMLHttpRequest();
    //         xhr.open("POST", "${url}/leads/upload-excel");
    //         xhr.setRequestHeader("Content-Type", "application/json");

    //         xhr.upload.onprogress = (e) => {
    //             if (e.lengthComputable) {
    //                 const percentComplete = Math.round((e.loaded / e.total) * 100);
    //                 setUploadProgress(percentComplete);
    //             } else {
    //                 let simulatedProgress = 0;
    //                 const interval = setInterval(() => {
    //                     simulatedProgress += 10;
    //                     setUploadProgress(Math.min(simulatedProgress, 99));
    //                     if (simulatedProgress >= 99) clearInterval(interval);
    //                 }, 200);
    //             }
    //         };

    //         xhr.onload = () => {
    //             if (xhr.status === 200) {
    //                 const response = JSON.parse(xhr.responseText);

    //                 setExcelUploadSuccess(true);
    //                 setUploadProgress(0);
    //                 setTimeout(() => setExcelUploadSuccess(false), 3000);
    //                 setShowExcelModal(false);
    //                 fetchLeadsData();

    //                 if (response.skippedEnquiries && response.skippedEnquiries.length > 0) {
    //                     setSkippedEnquiries(response.skippedEnquiries); // ✅ Save skipped enquiries
    //                     setShowSkippedModal(true); // ✅ Open skipped enquiry modal
    //                 }

    //             } else {
    //                 const response = JSON.parse(xhr.responseText);
    //                 alert(`Upload failed: ${response.message}`);
    //                 setUploadProgress(0);
    //             }
    //         };


    //         xhr.onerror = () => {
    //             alert("Network error occurred during upload.");
    //             setUploadProgress(0);
    //         };

    //         xhr.send(JSON.stringify({ enquiries: jsonData }));
    //     };

    //     reader.readAsArrayBuffer(file);
    // };

    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name); // ✅ Set uploaded filename
        setUploadProgress(0); // ✅ Reset progress
        setExcelUploadSuccess(false); // ✅ Reset success

        const reader = new FileReader();
        reader.onload = async (event) => {
            let jsonData;
            try {
                jsonData = await readFirstSheetAsJson(event.target.result);
            } catch (err) {
                console.error(err);
                toast.error("Could not read spreadsheet file.");
                return;
            }

            jsonData = jsonData.map(entry => ({
                ...entry,
                property_id: isLoggedIn.main_id
            }));

            const xhr = new XMLHttpRequest();
            xhr.open("POST", `${url}/leads/upload-excel`);
            xhr.setRequestHeader("Content-Type", "application/json");
            //  Authorization: `Bearer ${token}`,
            xhr.setRequestHeader("Authorization", `Bearer ${token}`)
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const percentComplete = Math.round((e.loaded / e.total) * 100);
                    setUploadProgress(percentComplete);
                } else {
                    let simulatedProgress = 0;
                    const interval = setInterval(() => {
                        simulatedProgress += 5;
                        setUploadProgress(Math.min(simulatedProgress, 99));
                        if (simulatedProgress >= 99) clearInterval(interval);
                    }, 100);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    toast.success("Excel Uploaded")
                    setExcelUploadSuccess(true); // ✅ Show success message
                    setUploadProgress(100);       // ✅ Full bar

                    // ✅ Important: Don't immediately close modal if skippedEnquiries exist
                    if (response.skippedEnquiries && response.skippedEnquiries.length > 0) {
                        setSkippedEnquiries(response.skippedEnquiries);
                        setShowSkippedModal(true); // Show skipped data
                    } else {
                        // Only close upload modal if no skipped enquiries
                        setTimeout(() => {
                            setShowExcelModal(false);
                            setExcelUploadSuccess(false);
                        }, 2000);
                    }

                    fetchLeadsData(); // Refresh data
                } else {
                    const response = JSON.parse(xhr.responseText);
                    alert(`Upload failed: ${response.message}`);
                    setUploadProgress(0);
                }
            };

            xhr.onerror = () => {
                alert("Network error occurred during upload.");
                setUploadProgress(0);
            };

            xhr.send(JSON.stringify({ enquiries: jsonData }));
        };

        reader.readAsArrayBuffer(file);
    };

    const applyFilters = () => {
        return leads.filter(lead => {

            if (searchTerm.trim() !== '') {
                const searchMatch = [
                    lead.name,
                    lead.business_name,
                    lead.address,
                    lead.source,
                    lead.came_from,
                    lead.parent_name,
                    lead.extra,
                    lead.email,
                    lead.mobile,
                    lead.remark,
                    lead.createdAt,
                    lead.staff_name,
                    lead.staff_id,
                    lead.enquiry_source,
                    lead.pincode,
                    lead.city
                ].some((field) => field?.toString().toLowerCase().includes(searchTerm.toLowerCase()));

                if (!searchMatch) return false;
            }

            if (notConnectedFilter && lead.mark !== "New") return false;
            if (selectedStatus && lead.extra?.toLowerCase() !== selectedStatus.toLowerCase()) return false;

            // 🔸 Status filter
            // if (selectedStatus && lead.extra?.toLowerCase() !== selectedStatus.toLowerCase()) return false;
            if (notes.trim() !== "" && lead.noteCount === 0) return false;

            if (selectedService && lead.parent_name?.toLowerCase() !== selectedService.toLowerCase()) return false;


            // 🔸 Starred filter
            const isStarred = lead.star === true || lead.star === "true" || lead.star === 1 || lead.star === "1";
            if (filterStarred && !isStarred) return false;

            // 🔸 Date filter logic
            if (selectedDate) {
                const leadDate = new Date(lead.createdAt).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });

                if (selectedDate === "today") {
                    const today = new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== today) return false;
                } else if (selectedDate === "yesterday") {
                    const yesterday = new Date();
                    yesterday.setDate(yesterday.getDate() - 1);
                    const yesterdayStr = yesterday.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== yesterdayStr) return false;
                } else if (selectedDate === "tomorrow") {
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    const tomorrowStr = tomorrow.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== tomorrowStr) return false;
                } else if (selectedDate === "custom") {
                    if (!customDate.from || !customDate.to) return false;

                    const leadTimestamp = new Date(lead.createdAt).setHours(0, 0, 0, 0);
                    const fromTimestamp = new Date(customDate.from).setHours(0, 0, 0, 0);
                    const toTimestamp = new Date(customDate.to).setHours(0, 0, 0, 0);

                    if (leadTimestamp < fromTimestamp || leadTimestamp > toTimestamp) return false;
                }
            }

            return true;
        });
    };



    const fetchLeadsData = async () => {
        setLoadingHbtreal(true);
        try {
            const response = await fetch(`${url}/leads/getall`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }); // Fetch leads data
            const res = await response.json();
            setLeadsData(res);
            syncCrmRemindersFromLeads(res);
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });

        } finally {
            setLoadingHbtreal(false);
        }
    }


    const fetchLeadsAvg = async () => {
        setLoadingHbtreal(true);
        try {
            const response = await fetch(`${url}/leads/all`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errRes = await response.json().catch(() => ({}));
                throw new Error(errRes.message || `Failed to fetch leads avg: ${response.status}`);
            }

            const res = await response.json();

            // compute response times (connected_time - createdAt) in minutes
            const diffsInMinutes = res
                .map(lead => {
                    const created = lead.createdAt || lead.created_at || null;
                    const connected = lead.connected_time || lead.connectedAt || lead.connected_at || null;

                    if (!created || !connected) return null;

                    const createdTs = Date.parse(created);
                    const connectedTs = Date.parse(connected);

                    if (isNaN(createdTs) || isNaN(connectedTs) || connectedTs < createdTs) return null;

                    const diffMs = connectedTs - createdTs;
                    const diffMins = diffMs / (1000 * 60);
                    return diffMins;
                })
                .filter(v => v !== null && isFinite(v));

            if (diffsInMinutes.length === 0) {
                setAvgRespondMinutes(0);
                setAvgRespondDisplay("—");
                setIsPoorRespond(false);
            } else {
                const sum = diffsInMinutes.reduce((a, b) => a + b, 0);
                const avg = sum / diffsInMinutes.length;
                setAvgRespondMinutes(avg);
                setAvgRespondDisplay(formatMinutesToReadable(avg));
                setIsPoorRespond(avg > 30); // threshold 30 minutes
            }

        } catch (error) {
            toast.error(error.message || "Error fetching lead averages", {
                position: "top-center",
                autoClose: 2000,
            });
        } finally {
            setLoadingHbtreal(false);
        }
    };


    const handleEmployeeChange = (selectedOptions) => {
        setSelectedEmployees(selectedOptions || []);
    };

    const employeeOptions = staffList.map(staff => ({
        value: staff.emplyee_ID,
        label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`
    }));


    // useEffect(() => {
    //     setEntriesCount(1);
    // }, [leads]);
    const applyCombinedFilters = () => {
        if (!filtersApplied) return leads;

        return leads.filter(lead => {
            // ✅ Enquiry Status (from 'extra')
            if (notConnectedFilter && lead.mark !== "New") return false;
            if (selectedStatus && lead.extra?.toLowerCase() !== selectedStatus.toLowerCase()) return false;

            // ✅ Service filter
            // if (selectedService && lead.related_service?.toLowerCase() !== selectedService.toLowerCase()) return false;

            // ✅ Notes filter
            // if (notes.trim() !== "" && (!lead.remark || lead.remark.trim() === "")) return false;

            // ✅ Starred
            const isStarred = lead.star === true || lead.star === 'true' || lead.star === 1 || lead.star === '1';
            if (filterStarred && !isStarred) return false;
            if (notes === 'withNotes' && (!lead.noteCount || lead.noteCount === 0)) return false;
            if (selectedServices.length && !selectedServices.includes(lead.parent_name)) return false;
            if (selectedEnquiryTypes.length && !selectedEnquiryTypes.includes(lead.extra)) return false;

            if (selectedDateOptions.length > 0) {
                const leadDate = new Date(lead.createdAt).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });

                const today = new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                const yesterdayDate = new Date();
                yesterdayDate.setDate(yesterdayDate.getDate() - 1);
                const yesterday = yesterdayDate.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });

                let match = false;

                if (selectedDateOptions.includes("today") && leadDate === today) match = true;
                if (selectedDateOptions.includes("yesterday") && leadDate === yesterday) match = true;

                if (selectedDateOptions.includes("custom")) {
                    if (customDate.from && customDate.to) {
                        const leadTimestamp = new Date(lead.createdAt).setHours(0, 0, 0, 0);
                        const fromTimestamp = new Date(customDate.from).setHours(0, 0, 0, 0);
                        const toTimestamp = new Date(customDate.to).setHours(0, 0, 0, 0);

                        if (leadTimestamp >= fromTimestamp && leadTimestamp <= toTimestamp) match = true;
                    }
                }

                if (!match) return false;
            }



            return true;
        });
    };






    useEffect(() => {
        fetchLeadsData();
        fetchLeadsAvg();
        ensureCrmNotificationPermission();
    }, [])

    const allFilteredLeads = filterMode === "combined" ? applyCombinedFilters() : applyFilters();

    // For tab-specific display
    const filteredLeads = (() => {
        switch (activeTab) {
            case "new":
                return allFilteredLeads.filter(lead => lead.mark === "New" && !lead.archieve);
            case "assigned":
                return allFilteredLeads.filter(lead => lead.staff_id && lead.staff_name && !lead.archieve);
            case "unassigned":
                return allFilteredLeads.filter(lead => !lead.staff_id && !lead.staff_name && !lead.archieve);
            case "reminder":
                return allFilteredLeads.filter(lead => lead.remainder_date && lead.remainder_time && !lead.archieve);
            case "archive":
                return allFilteredLeads.filter(lead => lead.archieve === true || lead.archieve === "true");
            case "website":
                return allFilteredLeads.filter(lead => lead.dob && !lead.archieve);
            default:
                return allFilteredLeads.filter(lead => !lead.archieve);
        }
    })();

    useEffect(() => {
        const filtered = services.filter(service =>
            service.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredServices(filtered);
    }, [services, searchTerm]);

    const handleShowMore = () => setVisibleCount(prev => prev + 10);



    const filteredCurrentLeads = employeeViewFilter
        ? allFilteredLeads.filter((lead) => lead.staff_id === employeeViewFilter)
        : allFilteredLeads;



    // ✅ Use this for All Enquiry count display (doesn't change based on tab)
    const totalAllCount = allFilteredLeads.filter(lead => ((lead.mark === "New" || lead.mark === "Read") && !lead.archieve)).length;
    const totalNewCount = allFilteredLeads.filter(lead => lead.mark === "New" && !lead.archieve).length;
    const totalAssignedCount = allFilteredLeads.filter(lead => lead.staff_id && lead.staff_name && !lead.archieve).length;
    const totalUnassignedCount = allFilteredLeads.filter(lead => !lead.staff_id && !lead.staff_name && !lead.archieve).length;
    const totalWebsite = allFilteredLeads.filter(lead => lead.dob && !lead.archieve).length;
    const totalNewConverted = allFilteredLeads.filter(lead => lead.extra === "Converted" && !lead.archieve).length;
    const totalNewInProgress = allFilteredLeads.filter(lead => lead.extra === "In Progress" && !lead.archieve).length;
    const totalNewPending = allFilteredLeads.filter(lead => lead.extra === "Pending" && !lead.archieve).length;
    const totalNewNotInterested = allFilteredLeads.filter(lead => lead.extra === "Not Interested" && !lead.archieve).length;


    const totalReminderCount = allFilteredLeads.filter(lead => lead.remainder_date && lead.remainder_time && !lead.archieve).length;

    const totalArchiveCount = allFilteredLeads.filter(
        (lead) => lead.archieve === true || lead.archieve === "true"
    ).length;



    // 🔹 Calculate total pages for filtered leads
    const totalPages = Math.ceil(filteredLeads.length / entriesCount);

    // 🔹 Get leads for the current page
    const indexOfLastLead = currentPage * entriesCount;
    const indexOfFirstLead = indexOfLastLead - entriesCount;
    const paginatedCurrentLeads = filteredLeads
        .filter((lead) => !employeeViewFilter || lead.staff_id === employeeViewFilter)
        .slice(indexOfFirstLead, indexOfLastLead);



    // 🔹 Handle page change
    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            setSelectAll(false); // Reset "Select All" checkbox
            setSelectedLeads([]); // Clear all selected checkboxes when changing page
        }
    };

    const toggleAssignSection = () => {
        if (showAssignSection) {
            // Clear all selected checkboxes when closing
            setSelectedLeads([]);
            setSelectAll(false);
        }
        setShowAssignSection(!showAssignSection);
        setShowAssignSectionMain(false);
    };

    const toggleAssignSectionMain = () => {
        if (showAssignSectionMain) {
            setSelectedLeads([]);
            setEmployeeViewFilter("")
            setSelectAll(false);
        }
        setShowAssignSectionMain(!showAssignSectionMain);
        setShowAssignSection(false);

    };

    const toggleAssignSectionArchive = () => {
        if (showAssignSectionArchive) {
            setSelectedLeads([]);
            setEmployeeViewFilter("")
            setSelectAll(false);
        }
        setShowAssignSectionArchive(!showAssignSectionArchive);
        setShowAssignSection(false);
        setShowAssignSectionMain(false);
    };

    const [newlyAssignedLeads, setNewlyAssignedLeads] = useState([]);
    const [alreadyAssignedLeads, setAlreadyAssignedLeads] = useState([]);


    const handleSelectAll = () => {
        setSelectedLeads(prevSelected => ({
            ...prevSelected,
            [currentPage]: selectAll ? [] : paginatedCurrentLeads.map(lead => lead.id),
        }));
        setSelectAll(!selectAll);
        setNewlyAssignedLeads([]);
        setAlreadyAssignedLeads([]);
    };




    // 🔹 Handle Assign
    const handleAssign = async () => {
        if (selectedEmployees.length === 0 || Object.keys(selectedLeads).length === 0) {
            alert("Please select at least one employee and one lead.");
            return;
        }

        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("No valid leads selected.");
            return;
        }

        // Build staffList payload for backend
        const staffListPayload = selectedEmployees.map(emp => ({
            staff_id: emp.value,
            staff_name: emp.label
        }));

        const payload = {
            leadIds: extractedLeadIds,
            staffList: staffListPayload
        };

        try {

            const response = await fetch(`${url}/leads/assign-leads`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                ;
                alert("Leads Assigned Successfully!");

                // ✅ Update UI with new assignments
                setLeadsData((prevLeads) =>
                    prevLeads.map((lead) => {
                        const assigned = res.newAssignments.filter(a => a.enquiry_id === lead.id);
                        if (assigned.length > 0) {
                            return {
                                ...lead,
                                assignedStaff: [
                                    ...(lead.assignedStaff || []),
                                    ...assigned.map(a => ({
                                        staff_id: a.staff_id,
                                        staff_name: a.staff_name
                                    }))
                                ]
                            };
                        }
                        return lead;
                    })
                );
            } else {
                console.error("Error assigning leads:", res);
                alert(`Error: ${res.message}`);
            }
        } catch (error) {
            console.error("Error assigning leads:", error);
            alert("An error occurred while assigning leads.");
        }
    };


    // 🔹 Handle Unassign
    const handleUnassign = async () => {
        if (Object.keys(selectedLeads).length === 0) {
            alert("Please select at least one lead to unassign.");
            return;
        }

        // Extract selected lead IDs
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("No valid leads selected.");
            return;
        }

        // Extract staff IDs from selected employees
        const staffIds = selectedEmployees.map(emp => emp.value);

        const payload = {
            leadIds: extractedLeadIds,
            staffIds: staffIds.length > 0 ? staffIds : undefined // optional
        };

        try {

            const response = await fetch(`${url}/leads/unassign-leads`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert("Leads Unassigned Successfully!");
                fetchLeadsData(); // refresh
                setSelectedEmployees([]); // reset employees
            } else {
                console.error("Error unassigning leads:", res);
                alert(`Error: ${res.message}`);
            }
        } catch (error) {
            console.error("Error unassigning leads:", error);
            alert("An error occurred while unassigning leads.");
        }
    };



    const handleArchive = async () => {
        // Extract selected lead IDs
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("Please select at least one lead to archive.");
            return;
        }

        const payload = { inquiryIds: extractedLeadIds };

        try {
            const response = await fetch(`${url}/leads/archive-inquiries`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert(`Archived ${res.archivedCount} leads successfully.`);
                // ✅ Refresh leads data
                fetchLeadsData();
                setSelectedLeads([]);
                setSelectAll(false);
                setShowAssignSectionArchive(false);
            } else {
                alert(`Failed to archive leads: ${res.message}`);
            }
        } catch (error) {
            console.error("Error archiving leads:", error);
            alert("An error occurred while archiving leads.");
        }
    };



    const SearchStaff = async () => {
        try {
            const response = await fetch(`${url}/staff`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const res = await response.json();
            if (response.ok) {
                setStaffList(res);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }

    };





    const fetchLeadsDataNotes = async () => {
        try {
            const response = await fetch(`${url}/leads/getall`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
            );
            const res = await response.json();
            const leadsWithNotes = await Promise.all(res.map(async (lead) => {
                const notesResponse = await fetch(`${url}/notec/all/${lead.id}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const notesData = await notesResponse.json();
                return { ...lead, noteCount: notesData.length }; // Add `noteCount` to each lead
            }));

            setLeadsData(leadsWithNotes);

        } catch (error) {
            console.error(error);
        }
    };

    const handleUnarchive = async () => {
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("Please select at least one lead to unarchive.");
            return;
        }

        const payload = { inquiryIds: extractedLeadIds };

        try {
            const response = await fetch(`${url}/leads/unarchive-inquiries`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert(`Unarchived ${res.unarchivedCount} leads successfully.`);
                fetchLeadsData();
                setSelectedLeads([]);
                setSelectAll(false);
                setShowAssignSectionArchive(false);
            } else {
                alert(`Failed to unarchive leads: ${res.message}`);
            }
        } catch (error) {
            console.error("Error unarchiving leads:", error);
            alert("An error occurred while unarchiving leads.");
        }
    };



    useEffect(() => {
        SearchStaff();
        fetchLeadsDataNotes();
    }, [])

    const toggleSection = (section) => {
        setShowAssignSection(section === 'assign' ? !showAssignSection : false);
        setShowCheckAssignSection(section === 'checkAssign' ? !showCheckAssignSection : false);
        setShowArchiveSection(section === 'archive' ? !showArchiveSection : false);
        setShowUploadModal(section === 'upload' ? !showUploadModal : false);
    };

    const crmMetrics = [
        {
            label: "Total Leads",
            value: totalAllCount,
            icon: UserPlus, // you can change icon as needed
            bg: "from-purple-300/20 to-blue-300/20",
            iconBg: "from-purple-500 to-blue-500",
        },
        {
            label: "Converted",
            value: totalNewConverted,
            icon: CheckCircle,
            bg: "from-emerald-300/20 to-green-300/20",
            iconBg: "from-emerald-500 to-green-600",
        },
        {
            label: "In Progress",
            value: totalNewInProgress,
            icon: Clock1,
            bg: "from-yellow-200/20 to-orange-200/20",
            iconBg: "from-yellow-500 to-orange-500",
        },
        {
            label: "Pending",
            value: totalNewPending,
            icon: Hourglass,
            bg: "from-blue-300/20 to-indigo-300/20",
            iconBg: "from-blue-600 to-indigo-500",
        },
        {
            label: "Not Interested",
            value: totalNewNotInterested,
            icon: XCircle,
            bg: "from-red-300/20 to-pink-300/20",
            iconBg: "from-red-500 to-pink-500",
        },
        {
            label: "Avg. Respond Time",
            value: "12h 30m",
            icon: Phone,
            bg: "from-teal-200/20 to-cyan-200/20",
            iconBg: "from-teal-500 to-cyan-500",
        },
    ];

    if (loadingHbtreal) {
        return (
            <Loader />
        );
    }


    return (
        <>

            <div className="flex overflow-x-auto no-scrollbar gap-4 mb-4">
                {crmMetrics.map((item, index) => {
                    const isAvgMetric = item.label === "Avg. Respond Time";
                    return (
                        <div
                            key={index}
                            className={`flex shrink-0 min-w-160 items-center gap-3 p-3 rounded-xl bg-gradient-to-br ${item.bg} backdrop-blur-md border border-white/40 shadow-sm`}
                        >
                            <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${item.iconBg} text-white flex items-center justify-center shadow-md`}>
                                <item.icon className="w-5 h-5" />
                            </div>

                            <div>
                                <p className={`text-lg md:text-xl font-bold ${isAvgMetric && isPoorRespond ? 'text-red-600' : 'text-gray-900'}`}>
                                    {isAvgMetric ? avgRespondDisplay : item.value}
                                </p>

                                <p className="text-[10px] sm:text-xs text-gray-600 font-medium">
                                    {item.label}
                                    {isAvgMetric && isPoorRespond && (
                                        <span style={{ display: 'block', color: '#b91c1c', fontSize: '10px', fontWeight: 600, marginTop: 4 }}>
                                            Poor respond time
                                        </span>
                                    )}
                                </p>
                            </div>
                        </div>
                    );
                })}

            </div>


            <div className="lsuv-oms">
                <div className="lsuv-oms__header">
                    <div className="lsuv-tabs-oms">
                        <div className={`lsuv-tab-oms ${activeTab === "all" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("all"); setCurrentPage(1); }}>
                            All Enquiry <span>({totalAllCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "new" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("new"); setCurrentPage(1); }}>
                            New <span>({totalNewCount})</span>
                        </div>
                        {/* <div className={`lsuv-tab-oms ${activeTab === "assigned" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("assigned"); setCurrentPage(1); }}>
                                Assigned <span>({totalAssignedCount})</span>
                            </div>
                            <div className={`lsuv-tab-oms ${activeTab === "unassigned" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("unassigned"); setCurrentPage(1); }}>
                                Unassigned <span>({totalUnassignedCount})</span>
                            </div> */}
                        <div className={`lsuv-tab-oms ${activeTab === "reminder" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("reminder"); setCurrentPage(1); }}>
                            Reminders <span>({totalReminderCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "archive" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("archive"); setCurrentPage(1); }}>
                            Archive <span>({totalArchiveCount})</span>
                        </div>
                        {/* <div className={`lsuv-tab-oms ${activeTab === "website" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("website"); setCurrentPage(1); }}>
                                Website <span>({totalWebsite})</span>
                            </div> */}
                    </div>
                    <div className="lsuv-header-icons-oms">
                        <div className="lsuv-search-oms" onClick={() => setShowSearchBar(!showSearchBar)}>
                            <i className="fa-solid fa-magnifying-glass"></i>
                        </div>
                        <div className="lsuv-filter-oms" onClick={toggleFilterDrawer}>
                            <i className="fa-solid fa-filter"></i>
                        </div>
                        <div className="lsuv-three-dots" onClick={() => setShowDropdown(!showDropdown)} ref={dropdownRef}>
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                            {showDropdown && (
                                <div className="lsuv-dropdown-menu">
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("assign")}>
                                        Assign leads
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("checkAssign")}>
                                        Check assign
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("archive")}>
                                        Archive
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("upload")}>
                                        Upload excel
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => openEnquiryModal("manual")}>
                                        Add Enquiry
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => openEnquiryModal("voice")}>
                                        <i className="fa-solid fa-microphone" aria-hidden="true" /> Voice Enquiry
                                    </div>
                                    <div className="lsuv-dropdown-item" >
                                        <a
                                            href="/sample_invoice.xlsx"
                                            download
                                            style={{ textDecoration: "none" }}
                                        >
                                            Download  Sample
                                        </a>
                                    </div>
                                    <a style={{ textDecoration: "none" }} href="mailto:support@100billiontech.com" aria-label="Email Customer Support">
                                        <div className="lsuv-dropdown-item">Support</div>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {showSearchBar && (
                    <div className="lsuv-searchbar-container">
                        <input
                            type="text"
                            className="lsuv-searchbar-input"
                            placeholder="Search enquiries..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                )}
                {showFilterDrawer && (
                    <div className={`lsuv-filter-drawer ${!showFilterDrawer ? 'closed' : ''}`}>
                        <div className="lsuv-filter-drawer-header">
                            <div className="lsuv-span-and-back-oms">
                                <i class="fa-solid fa-chevron-left" onClick={toggleFilterDrawer}></i>
                                <span>Filter Options</span>
                            </div>
                            <button onClick={handleClearFilters}>Clear</button>
                        </div>
                        <div className="lsuv-filter-drawer-content">
                            <div className="lsuv-filter-group-oms">
                                <p className="lsuv-filter-label">Filter by Date</p>
                                <div className="lsuv-filter-radio-group-oms">
                                    {['today', 'yesterday', 'custom'].map((value) => (
                                        <div className="lsuv-filter-radio-btn" key={value}>
                                            <input
                                                type="checkbox"
                                                id={value}
                                                name="datefilter"
                                                value={value}
                                                checked={selectedDateOptions.includes(value)}
                                                onChange={handleCheckboxDateChange}
                                            />
                                            <label htmlFor={value}>
                                                {value === 'today' && 'Today'}
                                                {value === 'yesterday' && 'Yesterday'}
                                                {value === 'custom' && 'Custom Date'}
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                {selectedDateOptions.includes('custom') && (
                                    <div className="lsuv-custom-date-range">
                                        <div className="lsuv-custom-date-input-oms">
                                            <label htmlFor="fromDate">From</label>
                                            <input
                                                type="date"
                                                id="fromDate"
                                                name="fromDate"
                                                value={customDate.from}
                                                onChange={(e) => setCustomDate({ ...customDate, from: e.target.value })}
                                            />
                                        </div>

                                        <div className="lsuv-custom-date-input-oms">
                                            <label htmlFor="toDate">To</label>
                                            <input
                                                type="date"
                                                id="toDate"
                                                name="toDate"
                                                value={customDate.to}
                                                onChange={(e) => setCustomDate({ ...customDate, to: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="lsuv-filter-group-oms">
                                <p className="lsuv-filter-label lsuv-others-filter-label">Filter by Others</p>
                                <div className="lsuv-filter-radio-group-oms">
                                    <div className="lsuv-filter-radio-btn">
                                        <input
                                            type="checkbox"
                                            id="star"
                                            name="others"
                                            checked={filterStarred}
                                            onChange={handleStarredChange}
                                        />
                                        <label htmlFor="star">
                                            <i className="fa-solid fa-star"></i>
                                            <span>Starred</span>
                                        </label>
                                    </div>

                                    <div className="lsuv-filter-radio-btn">
                                        <input
                                            type="checkbox"
                                            id="note"
                                            name="others"
                                            checked={notes === 'withNotes'}
                                            onChange={handleWithNotesChange}
                                        />
                                        <label htmlFor="note">
                                            <i className="fa-solid fa-note-sticky"></i>
                                            <span>With Notes</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="lsuv-filter-group-oms">
                                    <p className="lsuv-filter-label lsuv-others-filter-label">Filter by Category</p>
                                    <input
                                        type="text"
                                        className="lsuv-category-search-input"
                                        placeholder="Search services..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <div className="lsuv-category-checkbox-group">
                                        {filteredServices.slice(0, visibleCount).map((service, index) => (
                                            <div className="lsuv-category-checkbox" key={index}>
                                                <input
                                                    type="checkbox"
                                                    id={`cat-${index}`}
                                                    value={service}
                                                    checked={selectedServices.includes(service)}
                                                    onChange={() => toggleServiceSelection(service)}
                                                />
                                                <label htmlFor={`cat-${index}`}>{service}</label>
                                            </div>
                                        ))}
                                    </div>
                                    {visibleCount < filteredServices.length && (
                                        <button onClick={handleShowMore} style={{ marginTop: '10px' }}>
                                            View More
                                        </button>
                                    )}
                                </div> */}



                            <div className="lsuv-filter-group-oms">
                                <p className="lsuv-filter-label lsuv-others-filter-label">Filter by Enquiry Type</p>
                                <input
                                    type="text"
                                    className="lsuv-category-search-input"
                                    placeholder="Search enquiry type..."
                                    value={searchEnquiry}
                                    onChange={handleSearchEnquiryChange}
                                />
                                <div className="lsuv-category-checkbox-group">
                                    {filteredEnquiries.map((enquiry, index) => (
                                        <div className="lsuv-category-checkbox" key={index}>
                                            <input
                                                type="checkbox"
                                                id={`enq-${index}`}
                                                value={enquiry}
                                                checked={selectedEnquiryTypes.includes(enquiry)}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setSelectedEnquiryTypes(prev =>
                                                        prev.includes(value)
                                                            ? prev.filter(v => v !== value)
                                                            : [...prev, value]
                                                    );
                                                }}
                                            />
                                            <label htmlFor={`enq-${index}`}>{enquiry}</label>
                                        </div>
                                    ))}

                                </div>
                                {visibleEnquiries < allEnquiries.length && (
                                    <button className="lsuv-show-more-btn" onClick={handleShowMoreEnquiry}>
                                        Show More
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="lsuv-filter-drawer-footer-oms">
                            <button
                                className="lsuv-filter-drawer-close-btn"
                                onClick={handleApplyFilters}
                            >
                                Apply Filter
                            </button>
                        </div>
                    </div>
                )}

                {showAssignSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowAssignSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className="lsuv-assign-row">
                            <div className="lsuv-assign-checkbox">
                                <input type="checkbox" id="selectAll" checked={
                                    paginatedCurrentLeads.length > 0 &&
                                    selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                }
                                    onChange={handleSelectAll} />
                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-select">
                                <Select
                                    options={employeeOptions}
                                    isSearchable={true}   // ✅ Enable search
                                    isMulti               // ✅ Allow multiple
                                    placeholder="Search Employees"
                                    onChange={handleEmployeeChange}
                                    value={selectedEmployees}  // ✅ Show multiple selected employees
                                />
                            </div>

                        </div>
                        <div className="lsuv-assign-row-buttons">
                            <button className="lsuv-btn-assign" onClick={handleAssign}>Assign</button>
                            <button className="lsuv-btn-unassign" onClick={handleUnassign}>Unassign</button>
                        </div>
                    </div>
                )}

                {showCheckAssignSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowCheckAssignSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>

                        <div className="lsuv-assign-row">
                            <div className="lsuv-assign-checkbox">
                                <input type="checkbox" id="selectAll"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-select">
                                <Select
                                    options={staffList.map((staff) => ({
                                        value: staff.emplyee_ID,
                                        label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`,
                                    }))}
                                    placeholder="Filter by Assigned Employee"
                                    isClearable
                                    onChange={(selectedOption) =>
                                        setEmployeeViewFilter(selectedOption ? selectedOption.value : null)
                                    }
                                    value={
                                        employeeViewFilter
                                            ? {
                                                value: employeeViewFilter,
                                                label: staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.firstName +
                                                    " " +
                                                    staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.lastName
                                            }
                                            : null
                                    }
                                />
                            </div>
                        </div>
                        <div className="lsuv-assign-row-buttons">
                            <button className="lsuv-btn-unassign" onClick={handleUnassign}>Unassign</button>
                        </div>
                    </div>
                )}

                {showArchiveSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowArchiveSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className="lsuv-assign-row archive-div-oms">
                            <div className="lsuv-assign-checkbox">
                                <input type="checkbox" id="selectAll"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-row-buttons">
                                <button className="lsuv-btn-assign" onClick={handleArchive}>Archive</button>
                                <button className="lsuv-btn-unassign" onClick={handleUnarchive}>Unarchive</button>
                            </div>
                        </div>
                    </div>
                )}

                {showSkippedModal && (
                    <div className="modal-overlayskipped">
                        <div className="modal-containerskipped">
                            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Skipped Enquiries (Already Exist)</h2>
                            <div className="table-wrapper">
                                <table className="skipped-table">
                                    <thead>
                                        <tr>
                                            <th>Mobile Number</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Source</th>
                                            <th>Customer Type</th>
                                            <th>City</th>
                                            <th>Pincode</th>
                                            <th>Business Name</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {skippedEnquiries.map((entry, index) => (
                                            <tr key={index}>
                                                <td>{entry.mobile || '-'}</td>
                                                <td>{entry.name || '-'}</td>
                                                <td>{entry.email || '-'}</td>
                                                <td>{entry.source || entry.enquiry_source || '-'}</td>
                                                <td>{entry.type_customer}</td>
                                                <td>{entry.city || "-"}</td>
                                                <td>{entry.pincode || '-'}</td>
                                                <td>{entry.business_name || "-"}</td>
                                                <td>{entry.remark || '-'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <button
                                style={{
                                    marginTop: "20px",
                                    padding: "10px 20px",
                                    background: "#1a73e8",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    display: "block",
                                    marginLeft: "auto",
                                    marginRight: "auto"
                                }}
                                onClick={() => setShowSkippedModal(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}



                {/* {showUploadModal && (
                        <div className="lsuv-modal-overlay">
                            <div className="lsuv-modal-content">
                                <div className="lsuv-modal-header">
                                    <h3><i className="fa-solid fa-file-excel"></i> Upload Excel</h3>
                                    <button className="lsuv-close-btn" onClick={() => setShowUploadModal(false)}>
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                </div>

                                <p className="lsuv-modal-subtitle">Supported formats: <strong>.xls, .xlsx</strong></p>

                                <div className="lsuv-upload-wrapper">
                                    <input
                                        type="file"
                                        id="excel-upload"
                                        accept=".xls,.xlsx"
                                        onChange={handleExcelUpload}
                                        hidden
                                    />
                                    <label htmlFor="excel-upload" className="lsuv-upload-label">
                                        <i className="fa-solid fa-upload"></i> Select Excel File
                                    </label>
                                </div>

                                {uploadedFileName && (
                                    <p className="lsuv-uploaded-file-name">
                                        <i className="fa-solid fa-file"></i> {uploadedFileName}
                                    </p>
                                )}
                                {uploadProgress > 0 && (
                                    <div className="progress-bar-container">
                                        <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                                            {uploadProgress}%
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )} */}
                {showUploadModal && (
                    <div className="lsuv-modal-overlay">
                        <div className="lsuv-modal-content">
                            <div className="lsuv-modal-header">
                                <h3><i className="fa-solid fa-file-excel"></i> Upload Excel</h3>
                                <button className="lsuv-close-btn" onClick={() => {
                                    setShowUploadModal(false)
                                    setUploadProgress(0)
                                    setUploadedFileName(null)
                                    setExcelUploadSuccess(null)
                                }}>
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>

                            <p className="lsuv-modal-subtitle">Supported formats: <strong>.xls, .xlsx</strong></p>

                            <div className="lsuv-upload-wrapper">
                                <input
                                    type="file"
                                    id="excel-upload"
                                    accept=".xls,.xlsx"
                                    onChange={handleExcelUpload}
                                    hidden
                                />
                                <label htmlFor="excel-upload" className="lsuv-upload-label">
                                    <i className="fa-solid fa-upload"></i> Select Excel File
                                </label>
                            </div>

                            {/* ✅ Show Uploaded File Name */}
                            {uploadedFileName && (
                                <p className="lsuv-uploaded-file-name">
                                    <i className="fa-solid fa-file"></i> {uploadedFileName}
                                </p>
                            )}

                            {/* ✅ Show Loading Progress Bar */}
                            {uploadProgress > 0 && (
                                <div className="progress-bar-container">
                                    <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                                        {uploadProgress}%
                                    </div>
                                </div>
                            )}

                            {/* ✅ Show Excel Success Message */}
                            {excelUploadSuccess && (
                                <div style={{
                                    marginTop: "15px",
                                    padding: "10px",
                                    backgroundColor: "#d4edda",
                                    color: "#155724",
                                    border: "1px solid #c3e6cb",
                                    borderRadius: "5px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    fontSize: "14px"
                                }}>
                                    ✅ Excel uploaded successfully!
                                </div>
                            )}
                        </div>
                    </div>
                )}

            </div>

            <FilterTabs
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedStatuses={selectedEnquiryTypes}
                setSelectedStatuses={setSelectedEnquiryTypes}
                filterStarred={filterStarred}
                setFilterStarred={setFilterStarred}
                notesFilter={notes}
                setNotesFilter={setNotes}
                notConnectedFilter={notConnectedFilter}
                setNotConnectedFilter={setNotConnectedFilter}
                
            />


            {!showSearchBar && paginatedCurrentLeads.length > 0 && (
                <div className="pagination-ui-wrapper">
                    <div className="pagination-ui-entries">
                        <label>Entries:</label>
                        <select
                            value={entriesCount}
                            onChange={(e) => {
                                setEntriesCount(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>

                    <div className="pagination-ui-controls">
                        <button
                            className="pagination-ui-btn"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            <i class="fa-solid fa-chevron-left"></i>
                        </button>

                        <span className="pagination-ui-info">
                            {currentPage} of {totalPages}
                        </span>

                        <button
                            className="pagination-ui-btn"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            <i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            )}
            {paginatedCurrentLeads.length > 0 ? (
                <CRMUpdatedVersionCards
                    leads={paginatedCurrentLeads}
                    setLeads={setLeadsData}
                    selectedLeads={selectedLeads}
                    setSelectedLeads={setSelectedLeads}
                    currentPage={currentPage}
                    newlyAssignedLeads={newlyAssignedLeads}
                    setNewlyAssignedLeads={setNewlyAssignedLeads}
                    alreadyAssignedLeads={alreadyAssignedLeads}
                    setAlreadyAssignedLeads={setAlreadyAssignedLeads}
                    leadsDataMain={fetchLeadsData}
                />
            ) : (
                <div
                    className="flex flex-col items-center justify-center py-14 px-6 mt-2 mx-auto max-w-lg rounded-2xl border border-dashed border-gray-200 bg-gradient-to-b from-slate-50/90 to-white text-center"
                    role="status"
                    aria-live="polite"
                >
                    <div
                        className="flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-2xl bg-blue-50 text-blue-500 shadow-sm ring-1 ring-blue-100/80 mb-5"
                        aria-hidden
                    >
                        <UserPlus size={40} strokeWidth={1.5} />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 tracking-tight">
                        No enquiry found
                    </h3>
                    <p className="mt-2 text-sm text-gray-500 max-w-md leading-relaxed">
                        {leads.length === 0
                            ? "You have no enquiries yet. Add an enquiry or import leads to see them here."
                            : "No enquiries match the current tab, filters, or search. Try switching tabs, clearing filters, or adjusting your search."}
                    </p>
                </div>
            )}
            {!showSearchBar && paginatedCurrentLeads.length > 0 && (
                <div className='bottom-pagination-oms'>
                    <div className="pagination-ui-wrapper">
                        <div className="pagination-ui-entries">
                            <label>Entries:</label>
                            <select
                                value={entriesCount}
                                onChange={(e) => {
                                    setEntriesCount(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                            </select>
                        </div>

                        <div className="pagination-ui-controls">
                            <button
                                className="pagination-ui-btn"
                                onClick={() => paginate(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                <i class="fa-solid fa-chevron-left"></i>
                            </button>

                            <span className="pagination-ui-info">
                                {currentPage} of {totalPages}
                            </span>

                            <button
                                className="pagination-ui-btn"
                                onClick={() => paginate(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                <i class="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>

            )}

            <div className="crm-enquiry-fab-group">
                <button
                    type="button"
                    onClick={() => openEnquiryModal("voice")}
                    className="crm-enquiry-fab-voice"
                    aria-label="Add enquiry by voice"
                >
                    <i className="fa-solid fa-microphone" aria-hidden="true" />
                </button>
                <button
                    type="button"
                    onClick={() => openEnquiryModal("manual")}
                    className="cssbuttons-io-button"
                >
                    <span>Add Enquiry</span>
                </button>
            </div>
            <EnquiryFormModal
                showEnquiryModal={showEnquiryModal}
                closeModal={closeEnquiryModal}
                initialMode={enquiryInitialMode}
            />
            <ScrollToTopButton />

        </>
    );
};

export default CRMUpdatedVersion;